<script>
import { getSitemapEntry } from '../utils'

export default {
  props: {
    value: Object,
    scope: Object,
  },
  data() {
    return {
      title: this.value.data.path,
    }
  },
  created() {
    getSitemapEntry(this.scope, this.value.data.residential).then(entry => {
      if (!entry) return
      this.title = entry.pagetitle
    })
  },
}
</script>

<template>
  <i18n :path="value.event" tag="div">
    <template #url>
      <a :href="value.data.url" target="_blank">{{ title }}</a>
    </template>
  </i18n>
</template>
